import { X } from "lucide-react";
import { ChatHeaderProps } from "../types";

export default function ChatHeader({
  title = "New Chat",
  onClose,
}: ChatHeaderProps) {
  return (
    <div className="border-b border-zinc-200 bg-white px-4 py-3 flex items-center justify-between">
      <div className="flex items-center">
        <h2
          className="font-medium text-zinc-800 truncate max-w-[200px]"
          title={title}
        >
          {title}
        </h2>
      </div>
      <button onClick={onClose}>
        <X />
      </button>
    </div>
  );
}
